module.exports = __webpack_public_path__ + "img/natverksterminologi.0b8f0f86.jpg";